module.exports = __webpack_public_path__ + "media/images/proof_links/okko-0ea37368e9ff6fdea150b460e0aef713.svg";